import { combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';

import appReducer from './app';
import userReducer from './user';
import usersReducer from './users';
import internalNewsReducer from './internalNews';
import articleReducer from './article';
import carouselReducer from './carousel';
import sponsorReducer from './sponsor';
import uploadReducer from './upload';
import categoryReducer from './category';
import documentsReducer from './documents';
import pageReducer from './page';
import searchReducer from './search';
import menuReducer from './menu';
import videoReducer from './video';
import homeMenuReducer from './home-menu';
import homeStatReducer from './home-stat';
import homeBlockReducer from './home-block';
import footerMenuReducer from './footer-menu';

export default combineReducers({
  app: appReducer,
  user: userReducer,
  users: usersReducer,
  internalNews: internalNewsReducer,
  article: articleReducer,
  carousel: carouselReducer,
  sponsor: sponsorReducer,
  upload: uploadReducer,
  category: categoryReducer,
  documents: documentsReducer,
  intl: intlReducer,
  page: pageReducer,
  search: searchReducer,
  menu: menuReducer,
  video: videoReducer,
  homeMenu: homeMenuReducer,
  homeStat: homeStatReducer,
  homeBlock: homeBlockReducer,
  footerMenu: footerMenuReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js